import type { CopilotOverlayStore } from '@/shared/stores/ui';

import type { ProposedAction } from '@/entities/proposed-actions';
import type { SourceProposedActionT } from '@/shared/lib';

/**
 * Payload for the Prior Auth action wizard.
 *
 * ``action`` is optional because the tab can launch the wizard without a
 * proposed action — in that case we use the Lotus ``recordId`` to load the case.
 *
 * ``patientUserId`` is optional because proposed-action executions don't carry
 * it — the wizard fetches details directly by ``recordId`` and doesn't need
 * the patient context.
 */
export interface PriorAuthActionPrefill {
  recordId: string;
  patientUserId?: string;
  dosespotPrescriptionId?: string;
  action?: ProposedAction;
  sourceProposedAction?: SourceProposedActionT;
}

declare module '@/shared/stores/ui/copilotOverlay' {
  interface CopilotOverlayPayloads {
    priorAuthAction: PriorAuthActionPrefill;
  }
}

/**
 * Open the Prior Auth action wizard with its payload.
 */
export function openPriorAuthActionOverlay(
  overlays: CopilotOverlayStore,
  prefill: PriorAuthActionPrefill
): void {
  overlays.open('priorAuthAction', prefill);
}
